
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const AppPermissionType = {
  CAN_GIFT_POINTS: 'CAN_GIFT_POINTS',
  CAN_MANAGE_PARTICIPANTS: 'CAN_MANAGE_PARTICIPANTS',
  CAN_CREATE_ANNOUNCEMENTS: 'CAN_CREATE_ANNOUNCEMENTS',
  CAN_GENERATE_REPORT: 'CAN_GENERATE_REPORT'
} as const

export type AppPermissionType = (typeof AppPermissionType)[keyof typeof AppPermissionType]


export const AuditActions = {
  CREATE: 'CREATE',
  READ: 'READ',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE'
} as const

export type AuditActions = (typeof AuditActions)[keyof typeof AuditActions]


export const BlastStatus = {
  SENT: 'SENT',
  ERROR: 'ERROR'
} as const

export type BlastStatus = (typeof BlastStatus)[keyof typeof BlastStatus]


export const BooleanOptions = {
  TRUE: 'TRUE',
  FALSE: 'FALSE',
  EITHER: 'EITHER'
} as const

export type BooleanOptions = (typeof BooleanOptions)[keyof typeof BooleanOptions]


export const ComplimentStatus = {
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
  APPROVED: 'APPROVED',
  DENIED: 'DENIED'
} as const

export type ComplimentStatus = (typeof ComplimentStatus)[keyof typeof ComplimentStatus]


export const ContentSourceType = {
  URL: 'URL',
  FILE: 'FILE'
} as const

export type ContentSourceType = (typeof ContentSourceType)[keyof typeof ContentSourceType]


export const PlaybookStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
} as const

export type PlaybookStatus = (typeof PlaybookStatus)[keyof typeof PlaybookStatus]


export const PlayQuestionType = {
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  MULTI_SELECT: 'MULTI_SELECT',
  TRUE_FALSE: 'TRUE_FALSE',
  SHORT_ANSWER: 'SHORT_ANSWER',
  COMPLIMENT: 'COMPLIMENT',
  SLIDE: 'SLIDE',
  SURVEY_CHOICE: 'SURVEY_CHOICE'
} as const

export type PlayQuestionType = (typeof PlayQuestionType)[keyof typeof PlayQuestionType]


export const PlaybookEnrollmentStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED'
} as const

export type PlaybookEnrollmentStatus = (typeof PlaybookEnrollmentStatus)[keyof typeof PlaybookEnrollmentStatus]


export const EmploymentStatus = {
  FULL_TIME: 'FULL_TIME',
  PART_TIME: 'PART_TIME',
  PRN: 'PRN',
  PER_DIEM: 'PER_DIEM',
  AGENCY: 'AGENCY',
  FEE_FOR_SERVICE: 'FEE_FOR_SERVICE'
} as const

export type EmploymentStatus = (typeof EmploymentStatus)[keyof typeof EmploymentStatus]


export const EventType = {
  ACCEPT_TERMS_CONDITIONS: 'ACCEPT_TERMS_CONDITIONS',
  APPROVED: 'APPROVED',
  CONNECTIONS_ANNOUNCEMENT: 'CONNECTIONS_ANNOUNCEMENT',
  POST_COMMENT: 'POST_COMMENT',
  ERROR: 'ERROR',
  HELP: 'HELP',
  MATCH_DENIED: 'MATCH_DENIED',
  OPTIN: 'OPTIN',
  OTHER_DENIED: 'OTHER_DENIED',
  CONFIG_CHANGE: 'CONFIG_CHANGE',
  PART_TIME_DENIED: 'PART_TIME_DENIED',
  PER_DIEM_DENIED: 'PER_DIEM_DENIED',
  POINTS: 'POINTS',
  POST_DELETED: 'POST_DELETED',
  PROGRAM: 'PROGRAM',
  REACTION: 'REACTION',
  REDEEM: 'REDEEM',
  SCHEDULE: 'SCHEDULE',
  SCHEDULE_CLICK: 'SCHEDULE_CLICK',
  SIGN_IN: 'SIGN_IN',
  SMS_OPTIN: 'SMS_OPTIN',
  SPECIALITY_DENIED: 'SPECIALITY_DENIED',
  START: 'START',
  STATUS: 'STATUS',
  STOP: 'STOP',
  SUPPORT: 'SUPPORT',
  TIER_ACHIEVED_ANNOUNCEMENT: 'TIER_ACHIEVED_ANNOUNCEMENT',
  TUMBLER_SCAN: 'TUMBLER_SCAN',
  UNRECOGNIZED: 'UNRECOGNIZED'
} as const

export type EventType = (typeof EventType)[keyof typeof EventType]


export const FeedType = {
  PERSONAL: 'PERSONAL',
  ACCOUNT: 'ACCOUNT',
  FACILITY: 'FACILITY',
  GROUP: 'GROUP',
  DIRECT_MESSAGE: 'DIRECT_MESSAGE',
  ACCOUNT_ADMIN: 'ACCOUNT_ADMIN',
  FACILITY_ADMIN: 'FACILITY_ADMIN'
} as const

export type FeedType = (typeof FeedType)[keyof typeof FeedType]


export const GratiaSpecialty = {
  REGISTERED_NURSE: 'REGISTERED_NURSE',
  RESPIRATORY_THERAPIST: 'RESPIRATORY_THERAPIST',
  LICENSED_PRACTICAL_VOCATIONAL_NURSE: 'LICENSED_PRACTICAL_VOCATIONAL_NURSE',
  MONITOR_TECH: 'MONITOR_TECH',
  CERTIFIED_NURSING_ASSISTANT: 'CERTIFIED_NURSING_ASSISTANT',
  NURSING_SUPERVISOR: 'NURSING_SUPERVISOR',
  RESPIRATORY_SUPERVISOR: 'RESPIRATORY_SUPERVISOR',
  ADMIN: 'ADMIN',
  BACK_OFFICE_STAFF: 'BACK_OFFICE_STAFF',
  TECHNICIAN: 'TECHNICIAN',
  INACTIVE: 'INACTIVE',
  UNKNOWN: 'UNKNOWN',
  ENVIRONMENTAL: 'ENVIRONMENTAL',
  NUTRITION_AND_DINING: 'NUTRITION_AND_DINING',
  UNIT_SECRETARY: 'UNIT_SECRETARY',
  OTHER: 'OTHER',
  CONTRACTOR: 'CONTRACTOR',
  THERAPY: 'THERAPY',
  COORDINATOR_PLANNER: 'COORDINATOR_PLANNER',
  SOCIAL_WORK: 'SOCIAL_WORK'
} as const

export type GratiaSpecialty = (typeof GratiaSpecialty)[keyof typeof GratiaSpecialty]


export const IngestJobStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  UPLOADED: 'UPLOADED'
} as const

export type IngestJobStatus = (typeof IngestJobStatus)[keyof typeof IngestJobStatus]


export const IncentiveType = {
  INITIAL_LOGIN: 'INITIAL_LOGIN',
  QUARTER_PRODUCTIVE_HOURS: 'QUARTER_PRODUCTIVE_HOURS',
  MILESTONE: 'MILESTONE',
  SHIFT_PICKUP: 'SHIFT_PICKUP',
  LOYALTY: 'LOYALTY',
  INITIAL_MILESTONE: 'INITIAL_MILESTONE',
  INITIAL_LOYALTY: 'INITIAL_LOYALTY',
  REFERRAL: 'REFERRAL',
  COMPLIMENTS: 'COMPLIMENTS',
  PRECEPTOR: 'PRECEPTOR',
  CARE_IQ: 'CARE_IQ',
  CHARTING_CHAMP: 'CHARTING_CHAMP',
  ATTENDANCE_ALLSTARS: 'ATTENDANCE_ALLSTARS',
  LIVING_LEGENDS: 'LIVING_LEGENDS',
  CONTENT_MONSTER: 'CONTENT_MONSTER'
} as const

export type IncentiveType = (typeof IncentiveType)[keyof typeof IncentiveType]


export const MessageTypes = {
  NOTIFICATION: 'NOTIFICATION',
  STANDARD: 'STANDARD',
  PROXIMITY: 'PROXIMITY',
  REFERRAL: 'REFERRAL',
  GENERAL: 'GENERAL',
  SENTIMENT: 'SENTIMENT',
  SHOUTOUT: 'SHOUTOUT',
  SHIFT_PICKUP: 'SHIFT_PICKUP',
  MILESTONE: 'MILESTONE',
  TWILIO: 'TWILIO'
} as const

export type MessageTypes = (typeof MessageTypes)[keyof typeof MessageTypes]


export const ParticipantGenderOptions = {
  MALE: 'MALE',
  FEMALE: 'FEMALE'
} as const

export type ParticipantGenderOptions = (typeof ParticipantGenderOptions)[keyof typeof ParticipantGenderOptions]


export const ParticipantGroupConfidence = {
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW'
} as const

export type ParticipantGroupConfidence = (typeof ParticipantGroupConfidence)[keyof typeof ParticipantGroupConfidence]


export const ParticipantGroupSource = {
  SELF_IDENTIFIED: 'SELF_IDENTIFIED',
  ALGORITHMIC: 'ALGORITHMIC',
  ADMIN_ASSIGNED: 'ADMIN_ASSIGNED'
} as const

export type ParticipantGroupSource = (typeof ParticipantGroupSource)[keyof typeof ParticipantGroupSource]


export const ParticipantGroupType = {
  UNIT: 'UNIT',
  ROLE: 'ROLE'
} as const

export type ParticipantGroupType = (typeof ParticipantGroupType)[keyof typeof ParticipantGroupType]


export const ParticipantGroupVisibility = {
  PUBLIC: 'PUBLIC',
  INTERNAL: 'INTERNAL'
} as const

export type ParticipantGroupVisibility = (typeof ParticipantGroupVisibility)[keyof typeof ParticipantGroupVisibility]


export const ParticipantStatusOptions = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
  ELIGIBLE: 'ELIGIBLE',
  NOT_ELIGIBLE: 'NOT_ELIGIBLE'
} as const

export type ParticipantStatusOptions = (typeof ParticipantStatusOptions)[keyof typeof ParticipantStatusOptions]


export const PointTransactionStatus = {
  BANKED: 'BANKED',
  DENIED: 'DENIED',
  PENDING: 'PENDING',
  REDEEMED: 'REDEEMED',
  EXPIRED: 'EXPIRED',
  CREDIT: 'CREDIT',
  CANCELED: 'CANCELED'
} as const

export type PointTransactionStatus = (typeof PointTransactionStatus)[keyof typeof PointTransactionStatus]


export const PostType = {
  RECOGNITION: 'RECOGNITION',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  MILESTONE: 'MILESTONE',
  BIRTHDAY: 'BIRTHDAY',
  TIER_ACHIEVEMENT: 'TIER_ACHIEVEMENT',
  LOYALTY: 'LOYALTY',
  WORK_ANNIVERSARY: 'WORK_ANNIVERSARY',
  COMPLIMENT: 'COMPLIMENT',
  ADMIN_ANNOUNCEMENT: 'ADMIN_ANNOUNCEMENT',
  POINT_AWARD: 'POINT_AWARD'
} as const

export type PostType = (typeof PostType)[keyof typeof PostType]


export const PostVisibilityStatus = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  DELETED_BY_USER: 'DELETED_BY_USER',
  DELETED_BY_ADMIN: 'DELETED_BY_ADMIN'
} as const

export type PostVisibilityStatus = (typeof PostVisibilityStatus)[keyof typeof PostVisibilityStatus]


export const ReactionType = {
  ACKNOWLEDGE: 'ACKNOWLEDGE',
  CELEBRATE: 'CELEBRATE',
  ENCOURAGE: 'ENCOURAGE'
} as const

export type ReactionType = (typeof ReactionType)[keyof typeof ReactionType]


export const ReportType = {
  ADMIN_PAYROLL: 'ADMIN_PAYROLL',
  APP_ENGAGEMENT: 'APP_ENGAGEMENT',
  MILESTONE: 'MILESTONE',
  OPTIN: 'OPTIN',
  POINTS_BREAKDOWN: 'POINTS_BREAKDOWN',
  PAYROLL: 'PAYROLL',
  PAYROLL_DIFF: 'PAYROLL_DIFF',
  REFERRAL: 'REFERRAL',
  SHIFT_PICKUP: 'SHIFT_PICKUP'
} as const

export type ReportType = (typeof ReportType)[keyof typeof ReportType]


export const RewardOptionCategories = {
  PAY_DIFFERENTIAL: 'PAY_DIFFERENTIAL'
} as const

export type RewardOptionCategories = (typeof RewardOptionCategories)[keyof typeof RewardOptionCategories]


export const ShiftPickupStatusOptions = {
  PENDING: 'PENDING',
  PRE_FINALIZED: 'PRE_FINALIZED',
  FINALIZED: 'FINALIZED',
  DELETED: 'DELETED'
} as const

export type ShiftPickupStatusOptions = (typeof ShiftPickupStatusOptions)[keyof typeof ShiftPickupStatusOptions]


export const ShiftType = {
  EIGHT: 'EIGHT',
  TWELVE: 'TWELVE'
} as const

export type ShiftType = (typeof ShiftType)[keyof typeof ShiftType]


export const Status = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
} as const

export type Status = (typeof Status)[keyof typeof Status]


export const SurveyQuestionCategory = {
  GENERAL: 'GENERAL',
  CONNECTION: 'CONNECTION',
  COMPENSATION: 'COMPENSATION',
  WORK_LIFE_BALANCE: 'WORK_LIFE_BALANCE',
  PROFESSSIONAL_GROWTH: 'PROFESSSIONAL_GROWTH',
  RECOGNITION_AND_REWARDS: 'RECOGNITION_AND_REWARDS',
  CULTURE_FIT: 'CULTURE_FIT',
  SHIFT_PICKUP_SENTIMENT: 'SHIFT_PICKUP_SENTIMENT',
  EMBERS: 'EMBERS',
  EMBERS_FOLLOW_TO_BATTLE: 'EMBERS_FOLLOW_TO_BATTLE',
  EMBERS_MULTI_TASKER: 'EMBERS_MULTI_TASKER',
  EMBERS_PATIENT_WHISPERER: 'EMBERS_PATIENT_WHISPERER',
  EMBERS_FUNNIEST: 'EMBERS_FUNNIEST',
  EMBERS_SHIFTS: 'EMBERS_SHIFTS',
  EMBERS_WIZARD: 'EMBERS_WIZARD',
  EMBERS_COOLEST: 'EMBERS_COOLEST',
  EMBERS_READY_TO_HELP: 'EMBERS_READY_TO_HELP',
  KNOWLEDGE_CHECK: 'KNOWLEDGE_CHECK'
} as const

export type SurveyQuestionCategory = (typeof SurveyQuestionCategory)[keyof typeof SurveyQuestionCategory]


export const SurveyQuestionType = {
  PULSE: 'PULSE',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  SHORT_ANSWER: 'SHORT_ANSWER',
  EMBERS: 'EMBERS'
} as const

export type SurveyQuestionType = (typeof SurveyQuestionType)[keyof typeof SurveyQuestionType]


export const SurveyStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED'
} as const

export type SurveyStatus = (typeof SurveyStatus)[keyof typeof SurveyStatus]


export const SurveyToAccountIdentifier = {
  CURRENT: 'CURRENT'
} as const

export type SurveyToAccountIdentifier = (typeof SurveyToAccountIdentifier)[keyof typeof SurveyToAccountIdentifier]


export const SurveyType = {
  GENERAL: 'GENERAL',
  SHIFT_PICKUP: 'SHIFT_PICKUP',
  EMBERS: 'EMBERS',
  KNOWLEDGE_CHECK: 'KNOWLEDGE_CHECK'
} as const

export type SurveyType = (typeof SurveyType)[keyof typeof SurveyType]


export const UserRole = {
  GRATIA_ADMIN: 'GRATIA_ADMIN',
  CLIENT_SITE_ADMIN: 'CLIENT_SITE_ADMIN',
  CLIENT_GLOBAL_ADMIN: 'CLIENT_GLOBAL_ADMIN',
  USER: 'USER',
  ADMIN: 'ADMIN'
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]
